export default {"src":"/_next/static/image/public/images/ic_checkbox_checked_blue.fc2a01b63a2514224781934394c827bc.svg","height":22,"width":21};